<div class="my-3 relative flex items-center">
    <button class="m-auto relative rounded-xl cursor-pointer hover:bg-gray-200 p-3"
            (click)="toggleDropdown(); $event.stopPropagation()">
        <mat-icon class="icon-size-6" svgIcon="mat_outline:notifications"></mat-icon>
        <span *ngIf="unreadCount > 0"
              class="absolute top-1 -right-0 bg-red-500 text-white text-[10px] font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1">
            {{ unreadCount > 99 ? '99+' : unreadCount }}
        </span>
    </button>

    <div *ngIf="showDropdown" @fadeInOut
         class="fixed right-3 top-[86px] w-[400px] max-w-[calc(100vw_-_24px)] h-[410px] max-h-[calc(100vh_-_100px)] bg-white rounded-2xl shadow-2xl border border-gray-100 z-50 overflow-hidden flex flex-col md:absolute md:right-0 md:top-full md:mt-2"
         (click)="$event.stopPropagation()">

        <div class="flex items-center justify-between px-5 py-4">
            <span class="font-remote font-[600] text-[17px] text-gray-800">Notificações</span>
            <button *ngIf="unreadCount > 0" (click)="markAllRead()"
                    class="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-blue-50 hover:bg-blue-100 cursor-pointer transition-colors">
                <mat-icon class="icon-size-4 text-[#0061ff]" svgIcon="mat_solid:done_all"></mat-icon>
                <span class="font-inter font-[500] text-[12px] text-[#0061ff]">Marcar todas</span>
            </button>
        </div>

        <div *ngIf="loading" class="px-5 py-3">
            <div *ngFor="let i of [1,2,3]" class="flex items-center gap-4 px-2 py-3 animate-pulse">
                <div class="w-10 h-10 rounded-full bg-gray-200 flex-shrink-0"></div>
                <div class="flex-1 space-y-2">
                    <div class="h-3 bg-gray-200 rounded w-3/4"></div>
                    <div class="h-2 bg-gray-100 rounded w-1/2"></div>
                </div>
            </div>
        </div>

        <div *ngIf="!loading" @fadeIn class="overflow-y-auto overflow-x-hidden flex-1">
            <div *ngFor="let notification of notifications; last as isLast"
                 @slideOutRight
                 role="button"
                 tabindex="0"
                 (keydown.enter)="openNotificationDetail(notification)"
                 class="relative flex items-start gap-4 px-5 py-4 hover:bg-gray-50/80 cursor-pointer transition-colors"
                 [ngClass]="{
                     'bg-blue-50/30': !notification.readAt,
                     'border-b border-gray-50': !isLast
                 }"
                 (click)="openNotificationDetail(notification)">
                 <button class="absolute top-3 right-3 w-6 h-6 rounded-full flex items-center justify-center hover:bg-gray-200 cursor-pointer transition-colors"
                         (click)="dismissNotification($event, notification)">
                     <mat-icon class="icon-size-4 text-gray-400" svgIcon="mat_solid:close"></mat-icon>
                 </button>
                <div class="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
                     [ngClass]="{
                         'bg-green-100': notification.type === 'success',
                         'bg-red-100': notification.type === 'error',
                         'bg-blue-100': notification.type === 'info',
                         'bg-amber-100': notification.type === 'warning'
                     }">
                    <mat-icon class="icon-size-5"
                              [ngClass]="{
                                  'text-green-600': notification.type === 'success',
                                  'text-red-600': notification.type === 'error',
                                  'text-blue-600': notification.type === 'info',
                                  'text-amber-600': notification.type === 'warning'
                              }"
                              [svgIcon]="notification.type === 'success' ? 'mat_solid:check_circle' : notification.type === 'error' ? 'mat_solid:error' : notification.type === 'warning' ? 'mat_solid:warning' : 'mat_solid:info'">
                    </mat-icon>
                </div>
                <div class="flex-1 min-w-0 pr-6">
                    <div class="flex items-center justify-between gap-2">
                        <p class="font-inter font-[600] text-[13px] text-gray-800 truncate">{{ notification.title }}</p>
                        <div class="flex items-center gap-2 flex-shrink-0">
                            <span class="font-inter text-[11px] text-gray-400">{{ getTimeAgo(notification.createdAt) }}</span>
                            <div *ngIf="!notification.readAt" class="w-2 h-2 rounded-full bg-blue-500"></div>
                        </div>
                    </div>
                    <p *ngIf="notification.message" class="font-inter font-[400] text-[12px] text-gray-500 mt-1 leading-relaxed line-clamp-2 break-words">{{ notification.message }}</p>

                    <div *ngIf="notification.data?.minute_title" class="mt-2">
                        <span class="inline-flex items-center max-w-full truncate px-2.5 py-0.5 rounded-full text-[11px] font-inter font-[500] bg-gray-100 text-gray-600">
                            {{ notification.data.minute_title }}
                        </span>
                    </div>
                </div>
            </div>

            <div *ngIf="notifications.length === 0" @fadeIn class="flex flex-col items-center justify-center py-16">
                <div class="w-20 h-20 rounded-full bg-gray-100 flex items-center justify-center mb-4">
                    <mat-icon class="icon-size-10 text-gray-300" svgIcon="mat_outline:notifications_off"></mat-icon>
                </div>
                <span class="font-remote font-[600] text-[16px] text-gray-800 mb-1">Nenhuma notificação</span>
                <span class="font-inter text-[13px] text-gray-400">Você está em dia com tudo!</span>
                <button (click)="openAllNotifications()"
                        class="mt-4 flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-blue-50 hover:bg-blue-100 cursor-pointer transition-colors">
                    <span class="font-inter font-[500] text-[12px] text-[#0061ff]">Ver todas as notificações</span>
                </button>
            </div>
        </div>

        <div *ngIf="!loading && notifications.length > 0" class="border-t border-gray-100 px-5 py-3">
            <button (click)="openAllNotifications()"
                    class="w-full flex items-center justify-center gap-2 px-5 py-2 rounded-3xl bg-blue-50 hover:bg-blue-100 cursor-pointer transition-colors">
                <span class="font-remote font-[500] text-[14px] text-blue-700">Ver todas</span>
            </button>
        </div>
    </div>
</div>
